import PropTypes from 'prop-types'
import React, { Component } from 'react'

import { scrollToInlineComment } from '../utils'

const MAX_HIGHLIGHT_CHARACTERS = 80

class CommentHighlight extends Component {
  static propTypes = {
    content: PropTypes.string.isRequired,
    threadId: PropTypes.string.isRequired,
  }

  render() {
    const { content, threadId } = this.props

    return (
      <div
        onClick={e => scrollToInlineComment(e, threadId)}
        className="pointer line-height-large shade-05 margin-bottom-small"
      >
        <span className="comment-editor comment-highlighted radius-normal">
          {content.length > MAX_HIGHLIGHT_CHARACTERS
            ? `${content.slice(0, MAX_HIGHLIGHT_CHARACTERS)}...`
            : content}
        </span>
      </div>
    )
  }
}

export default CommentHighlight
